import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { isArray, isEmpty, join, map, reduce } from 'lodash';

import { zIndex } from '~/theme';
import { calcVw } from '~/styles/helpers';

// Auto import all background images
const imagesImport = require.context('~/images/backgrounds', true);
const getBackgroundsDirectory = (imagesImport) => {
    return reduce(
        imagesImport.keys(),
        (acc, imagePath) => {
            const key = imagePath.replace('./', '').replace('.png', '');
            return {
                ...acc,
                [key]: imagesImport(imagePath).default
            };
        },
        {}
    );
};

const backgrounds = getBackgroundsDirectory(imagesImport);

export const fullWidthBackgroundStyles = `
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    right: 50%;
    bottom: 0;
    margin: 0 ${calcVw(-50)};
    width: ${calcVw(100)};
    height: 100%;
`;

const getBackgroundImage = ({ theme, backgroundGraphic }) => {
    if (!isArray(backgroundGraphic) && !isEmpty(backgroundGraphic)) {
        return css`
            &::after {
                ${fullWidthBackgroundStyles}
                z-index: ${zIndex.backgroundGraphics};
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(${backgrounds[backgroundGraphic]});
            }
        `;
    }

    let backgroundImageUrls = join(
        map(backgroundGraphic, (graphic) => `url(${backgrounds[graphic]})`),
        ','
    );

    return css`
        &::after {
            ${fullWidthBackgroundStyles}
            z-index: ${zIndex.backgroundGraphics};
            background-size: 15%;
            background-repeat: no-repeat;
            background-image: ${backgroundImageUrls};
            background-position:
                left top,
                right bottom;

            @media (min-width: ${theme.breakpoint.largeTablet}) {
                background-size: 8%;
            }
        }
    `;
};

const Illustrations = styled.div`
    ${getBackgroundImage}
`;

const IllustrationsBackground = ({ backgroundGraphic, className = '' }) => (
    <Illustrations {...{ backgroundGraphic, className }} />
);

IllustrationsBackground.propTypes = {
    backgroundGraphic: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    className: PropTypes.string
};

export default IllustrationsBackground;
